import React from 'react';
import { Check, Circle } from 'lucide-react';
import { ShipmentData } from '../types';

interface TrackingResultProps {
  data: ShipmentData;
  onClose: () => void;
}

export const TrackingResult: React.FC<TrackingResultProps> = ({ data, onClose }) => {
  return (
    <div className="bg-white p-8 md:p-16 animate-fade-up">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end border-b border-stone-200 pb-8 mb-12">
        <div>
          <span className="block text-[10px] uppercase tracking-[0.3em] text-stone-500 mb-2">Tracking ID</span>
          <h2 className="font-serif text-4xl text-luxury-black">{data.id}</h2>
        </div>
        <div className="mt-6 md:mt-0 text-right">
           <span className="inline-block px-4 py-1.5 border border-stone-200 text-xs uppercase tracking-widest text-luxury-black">
            {data.status}
          </span>
          <p className="text-xs text-stone-500 mt-2 font-serif italic">Expected: {data.estimatedDelivery}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
         {/* Route */}
         <div className="col-span-1">
            <div className="flex flex-col gap-8">
               <div>
                  <span className="text-[10px] uppercase tracking-widest text-stone-400 block mb-1">From</span>
                  <span className="font-serif text-2xl block">{data.origin}</span>
               </div>
               <div className="w-px h-12 bg-stone-200 ml-1"></div>
               <div>
                  <span className="text-[10px] uppercase tracking-widest text-stone-400 block mb-1">To</span>
                  <span className="font-serif text-2xl block">{data.destination}</span>
               </div>
            </div>
         </div>

         {/* Timeline */}
         <div className="col-span-2">
            <div className="space-y-0">
               {data.events.map((event, index) => (
                  <div key={index} className="grid grid-cols-[80px_1fr] md:grid-cols-[120px_1fr] gap-8 group py-6 border-b border-stone-100 last:border-0 hover:bg-stone-50 transition-colors px-4 -mx-4">
                     <div className="text-right pt-1">
                        <span className="block text-xs font-bold text-luxury-black">{event.date}</span>
                        <span className="block text-[10px] text-stone-400 mt-1">{event.time}</span>
                     </div>
                     <div className="relative border-l border-stone-200 pl-8">
                        <div className={`absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full border border-white ${event.status === 'completed' ? 'bg-luxury-black' : 'bg-stone-200'}`}></div>
                        <h4 className="font-serif text-lg text-luxury-black mb-1">{event.description}</h4>
                        <p className="text-xs text-stone-500 uppercase tracking-wider">{event.location}</p>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </div>

      <div className="mt-12 text-center">
         <button onClick={onClose} className="text-xs uppercase tracking-[0.2em] border-b border-black pb-1 hover:text-greenline-800 hover:border-greenline-800 transition-colors">
            Close Viewer
         </button>
      </div>
    </div>
  );
};